import { Router } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";
import { MetaProvider, Title } from "@solidjs/meta";
import { Suspense, ErrorBoundary } from "solid-js";
import { Footer } from "~/components";
import { UserProvider } from "~/context/UserProvider";

import "./app.css";

export default () => (
	<Router
		root={props => (
			<ErrorBoundary fallback={( error, reset ) => <ErrorDisplay error={error} reset={reset} />}>
				<UserProvider>
					<MetaProvider>
						<Title>RIAS Regs</Title>

						<Suspense>{props.children}</Suspense>

						<Footer />
					</ MetaProvider>
				</UserProvider>
			</ErrorBoundary>
		)}
	>
		<FileRoutes />
	</Router>
);

const ErrorDisplay = ( props: { error: any, reset: () => void } ) => (
	<div class="p-0 m-0 max-w-225 bg-red-100 border border-red-300 text-red-700 px-4 py-3 rounded relative mx-auto my-56 flex flex-col items-center justify-center">
		<h1 class="text-3xl font-bold mb-4">Sorry, but something went wrong on RIASRegs</h1>

		<h2 class="text-xl mb-2">Error: {props.error.message}</h2>

		<p class="my-10 text-center">The development team will be notified, but please try again now or later.</p>

		<button type="button" class="" onClick={props.reset}>Try Again</button>
	</div>
);
